import { css, SimpleInterpolation } from 'styled-components';
import { PartnerCode, PartnerMap } from './models';
import { partners } from './data';

type PartnerStyler = typeof css;

const makePartnerStyler: (partnerCode: PartnerCode) => PartnerStyler = (partnerCode) => {
  const styler: PartnerStyler = (strings: TemplateStringsArray, ...interpolations: Array<SimpleInterpolation>) =>
    globals.REACT_APP_PARTNER === partners[partnerCode].reactAppPartner ? css(strings, ...interpolations) : [];
  return styler;
};

export const partnerStyled = Object.keys(partners).reduce(
  (acc, partnerCode: PartnerCode) => ({ ...acc, [partnerCode]: makePartnerStyler(partnerCode) }),
  {} as PartnerMap<PartnerStyler>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/partner/theming.tsx